export const socialPlatformsIcons = new Map([
    ['ALL SOCIAL NETWORKS', 'social-id'],
    ['FACEBOOK', 'facebook'],
    ['GOOGLE_PLUS', 'google-plus'],
    ['GOOGLE', 'google'],
    ['MYSPACE', 'myspace'],
    ['INSTAGRAM', 'instagram'],
    ['TWITTER', 'twitter'],
    ['VK', 'vkontakte'],
    ['VKONTAKTE', 'vkontakte'],
    ['SNAPCHAT', 'snapchat'],
    ['WIKIPEDIA', 'wikipedia'],
    ['LINKEDIN', 'linkedin'],
    ['WHATSAPP', 'whatsapp'],
    ['TELEGRAM', 'telegram'],
    ['SKYPE', 'skype'],
    ['WECHAT', 'wechat'],
    ['VIBER', 'viber'],
    ['TRUECALLER', 'truecaller'],
    ['LINE', 'line'],
    ['PINTEREST', 'pinterest'],
    ['YOUTUBE', 'youtube'],
    ['FOURSQUARE', 'foursquare'],
    ['PIPL', 'pipl'],
    ['CALLAPP', 'callapp'],
    ['DRUPE', 'drupe'],
    ['DUCKDUCKGO', 'duckduckgo'],
    ['LEXISNEXIS', 'lexisnexis'],
    ['ACCURINT', 'lexisnexis'],
    ['TIKTOK', 'tiktok'],
    ['EYECON', 'eyecon'],
    ['GETCONTACT', 'getcontact'],
    ['SYNCME', 'syncme'],
    ['AMAZON', 'amazon'],
    ['SAMSUNG', 'samsung'],
    ['ALIEXPRESS', 'aliexpress'],
    ['HIBP', 'haveibeenpwned'],
    ['HAVEIBEENPWNED', 'haveibeenpwned'],
    ['ME', 'me'],
    ['SKYPE', 'skype'],
    ['LAMPYRE', 'lampyre'],
    ['HIYA', 'hiya'],
    ['XING', 'xing'],
    ['MYSPACE', 'myspace'],
    ['YOUTUBE', 'youtube'],
    ['TWITCH', 'twitch'],
    ['CASHAPP', 'cashapp'],
    ['SHOWCALLER', 'showcaller'],
    ['SPOTIFY', 'spotify'],
    ['QUORA', 'quora'],
    ['EVENTBRITE', 'eventbrite'],
    ['APPLE', 'apple'],
    ['THATSTHEM', 'thatsthem'],
]);

export const addressesMap = new Map([
    ['ORIGIN', 'Origin Country'],
    ['HOME', 'Home'],
    ['WORK', 'Work'],
    ['OTHER', 'Other'],
    ['PROFILE LOCATION', 'Profile Location'],
]);

export enum AnalysisTypes {
    FullAnalysis = 'FullAnalysis',
    SocialAnalysis = 'SocialAnalysis',
    Lookup = 'Lookup',
}

export const InputTypeDisplayName: any = {
    general_username: 'Username',
    None: '',
    ByEmailAddress: 'Email',
    ByPhoneNumber: 'Phone',
    ByCpf: 'CPF',
    ByFid: 'Facebook ID',
    ByIid: 'Instagram ID',
    ByTid: 'Twitter ID',
    ByLid: 'LinkedIn ID',
    SearchPointer: 'Pipl ID',
    ByName: 'Name',
    ByIdn: 'IDN',
    hashtag: 'Hashtag',
    socialID: 'Social ID',
    ByPiplSearchPointer: 'Pipl ID',
    ByLexId: 'LexisNexis ID',
    pinterest_id: 'Pinterest ID',
    vkontakte_id: 'VKontakte ID',
    tiktok_id: 'TikTok ID',
    snapchat_id: 'Snapchat ID',
    xing_id: 'Xing ID',
    youtube_id: 'YouTube ID',
    twitch_id: 'Twitch ID',
    cashapp_id: 'CashApp ID',
};
